<div class="flex items-center gap-2" *ngIf="displayText">
  <div class="flex items-center gap-2">
    <app-active-user-avatar
      *ngFor="let user of users"
      [user]="user">
    </app-active-user-avatar>
    <span class="text-xs text-night">
      {{ displayText }}
      <span class="inline-flex items-center gap-1 ml-1">
        <div class="h-1 w-1 rounded-full bg-night animate-bounce-short"></div>
        <div class="h-1 w-1 rounded-full bg-night animate-bounce-delay-1"></div>
        <div class="h-1 w-1 rounded-full bg-night animate-bounce-delay-2"></div>
      </span>
    </span>
  </div>
</div>
